// Color Palette
//
// CRI Colors to be used app wide

/**
 * Light Theme Colors
 *
 * @constant lightColors
 */
export const lightColors = {
  primary: "#88B04B",
  secondary: "#FFD700",
  background: "#fefae0",
  secondaryBackground: "#FFFDF0",
  secondaryBackgroundText: "#212121",
  material: "#F5F5F5",
};

/**
 * Dark Theme Colors
 *
 * @constant darkColors
 */
export const darkColors = {
  primary: "#228B22", //
  secondary: "#90EE90",
  background: "#282c34",
  secondaryBackground: "#20232a",
  secondaryBackgroundText: "#212121",
  material: "#373d45",
};
